export const FbPadFileQuery = (FbPadFileId) => {
  return `{
    fbPadFile(id: ${FbPadFileId}) {
      id
      cassiopaeCode
      sparcCode
      totemCode
      nbSalespoint
      annualAmount
      user {
        firstname
        lastname
      }
      error {
        name
      }
      salespointName
      ownerName
      service
      status
      startingDate
      endingDate
      contentious {
        name
      }
      comments {
        id
        value
        date
        user {
          firstname
          lastname
        }
      }
      fbPadLines {
        id
        discount_HE
        discount_FB
        free_HE
        free_FB
        volume
        product {
          id
          name
          category {
            id
            name
          }
        }
        error {
          name
        }
        tax_rate
        unit
        lineStatus
        replaceLine {
          id
        }
      }
      commercial
    }
  }`
}
